<template>
  <div class="expertSettings">
    <TemporaryPopup ref="temporary-popup">
      {{ t('experts.copied') }}
    </TemporaryPopup>
    <table class="expertSettings__data">
      <template
        v-if="iotDeviceId?.toLowerCase()?.indexOf('none') === -1"
      >
        <tr>
          <td>{{ t('experts.meterMeasurementLabel') }}</td>
          <td>
            <a
              :href="
                'https://' + iotDeviceId + '.balena-devices.com/setup?token=' +
                encodeURIComponent(backendAccessToken)
              "
              target="_blank"
              class="expertSettings__link"
            >{{ t('experts.meterSetupLink') }} <IconExternal
            /></a>
          </td>
        </tr>
        <tr>
          <td>{{ t('experts.restartLabel') }}</td>
          <td>
            <a
              @click="restartCube()"
              style="cursor: pointer"
              target="_blank"
              class="expertSettings__link"
              id="expertSettings__restartButton"
            >{{ t('experts.restartLink') }} <IconExternal
            /></a>
            <span
              id="expertSettings__hiddenLabel"
              style="visibility: hidden; display: none"
            >{{ t('experts.restartRunning') }}</span
            >
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <em
            >{{ t('experts.restartNote') }}</em
            >
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2">
            {{ t('experts.hostnameNote') }}
          </td>
        </tr>
        <tr>
          <td>{{ t('experts.remoteHost') }}</td>
          <td>
            <em>
              {{ meterSocketHost }}
            </em>
            <button
              type="button"
              @click="copy(meterSocketHost)"
              class="button button--link socket-url__copy"
            >
              <IconCopy class="button-icon" />
            </button>
          </td>
        </tr>
        <tr>
          <td>{{ t('experts.localIp') }}</td>
          <td>
            <template v-if="localHostName">
              <em>
                {{ localHostName }}
              </em>
              <button
                type="button"
                @click="copy(localHostName)"
                class="button button--link socket-url__copy"
              >
                <IconCopy class="button-icon" />
              </button>
            </template>
            <template v-else>
              -
            </template>
        </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="2">
            <em>{{ t('experts.noExpertSettings') }}</em>
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script setup lang="ts">
import IconCopy from '@/components/icons/Copy.vue';
import IconExternal from '@/components/icons/External.vue';
import TemporaryPopup from '@/components/popups/TemporaryPopup.vue';
import { useStrings } from '@/composables/useStrings.ts';
import { useAuthStore } from '@/stores/useAuthStore';
import { useCubeStore } from '@/stores/useCubeStore';
import { computed, useTemplateRef, type ComponentPublicInstance, type Ref } from 'vue';

const { t } = useStrings()
const authStore = useAuthStore()
const cubeStore = useCubeStore()
const temporaryPopupRef: Ref<InstanceType<typeof TemporaryPopup>> = useTemplateRef('temporary-popup')

const backendAccessToken = computed(() => authStore.backendAccessToken)
const meterSocketHost = computed(() => cubeStore.meterSocketHost)
const localHostName = computed(() => cubeStore.localHostName)
const iotDeviceId = computed(() => cubeStore.iotDeviceId)

const copy = (value) => {
  navigator.clipboard.writeText(value)
  temporaryPopupRef.value.showTemporarily()
}

const restartCube = () => {
  cubeStore.restartCube()
  document.getElementById('expertSettings__restartButton').style.display = 'none'
  document.getElementById('expertSettings__restartButton').style.visibility = 'hidden'
  document.getElementById('expertSettings__hiddenLabel').style.display = 'block'
  document.getElementById('expertSettings__hiddenLabel').style.visibility = 'visible'

  setTimeout(() => {
    document.getElementById('expertSettings__restartButton').style.display = 'block'
    document.getElementById('expertSettings__restartButton').style.visibility = 'visible'
    document.getElementById('expertSettings__hiddenLabel').style.display = 'none'
    document.getElementById('expertSettings__hiddenLabel').style.visibility = 'hidden'
  }, 180000)
}
</script>

<style lang="scss">
.expertSettings {
  .button {
    vertical-align: bottom;

    .button-icon {
      max-width: 24px;
    }
  }

  &__data {
    border: 1px solid $grey-light;
    border-collapse: collapse;
  }

  &__link {
    font-size: $font-size-lg;
    color: $body-color;
    transition: $transition-base;

    .icon {
      width: 1em;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
.socket-url__copy {
  max-width: 3em;
  margin-left: 0.5rem;
}
</style>
